import { useEffect, useRef } from 'react';
import { useLoginVerify } from './useLoginVerify';
import { redirectToLogin } from '../utils/loginRedirect';
export function usePortalsAuth(options) {
  const {
    data: user,
    loading
  } = useLoginVerify();
  const isAccessDenied = !loading && !!user && user.requestedInstanceAccess === 'DENIED';
  const hasRedirectedRef = useRef(false);
  useEffect(() => {
    if (!loading && !user && !hasRedirectedRef.current) {
      hasRedirectedRef.current = true;
      redirectToLogin(options === null || options === void 0 ? void 0 : options.redirectUrl);
    }
  }, [loading, user, options === null || options === void 0 ? void 0 : options.redirectUrl]);
  return {
    isLoading: loading,
    isAccessDenied,
    user
  };
}